<script>
  import { project, postData } from "$lib/services/store";
  import { dateFormatter } from "$lib/services/utils";
  import Group from "$lib/admin/components/Group.svelte";
  import Block from "$lib/admin/components/blocks/helpers/Block.svelte";
  import Translate from "$lib/admin/components/blocks/helpers/Translate.svelte";

  export let props = null;
  export let adminView = false;
</script>

{#if adminView}
  <Group>
    <!-- svelte-ignore a11y-label-has-associated-control -->
    <label>Article last updated: {$postData?.updated_at}</label>
  </Group>
{:else}
  <div class="content-grid bg-background-secondary py-4 text-sm">
    <div class="flex gap-2">
      <strong class="uppercase"><Translate text="Last updated" />:</strong>
      <span class="date">{dateFormatter($postData?.updated_at, $project.settings.langAlt)}</span>
    </div>
  </div>
{/if}
